import { getSearchId } from '@tracking/services/location.service';
import { track, logError } from '@tracking';
import getShopBusinessType from '@core/reducers/shop/selectors/getShopBusinessType';
import locationToString from '@commons/models/LocationPoint/mappers/toStringWithCityAndCountry';
import { getCountryName } from '@shared/selectors';
import getSessionId from '@core/reducers/user/selectors/getSessionId';

const EVENT_NAME = 'map.closed';

const trackMapClosed = ({ trackingData, point }) => (_, getState) => {
  try {
    const state = getState();
    const countryName = getCountryName(state);
    const searchId = getSearchId();
    const dbSearchGuid = getSessionId(state);
    const businessType = getShopBusinessType(state);
    const { origin, mapAction, mapClick, optionClick, mapType } = trackingData;

    const payload = {
      searchId,
      dbSearchGuid,
      locationAddress: locationToString(point, countryName),
      mapAction,
      businessType,
      origin,
      mapClick,
      mapType,
      optionClick,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackMapClosed;
